module.exports = __webpack_public_path__ + "static/images/a433db0c1bbb9d48e378399eba745db6.webp";